<div class="flex flex-col gap-2">
    <app-input
        [label]="label()"
        [(value)]="inputValue"
        (inputKeydown)="keyup($event)"
        (inputBlur)="handleBlur()"
        [disabled]="disabled()"
        [required]="required()"
        [placeholder]="placeholder() || '입력 후 Enter'"
    />
    @if (value() && value()!.length > 0) {
        <div class="flex gap-3 items-center flex-wrap">
            @for (item of value(); track $index) {
                <app-name-tag (close)="removeChip($index)">{{
                    item
                }}</app-name-tag>
            }
        </div>
    }
</div>
